module.exports = __webpack_public_path__ + "img/circle-question-solid.59043c47.svg";